/**
 * Ícone de cada rotina, extraído do Delphi.
 *
 * A `ImageListColetor` do `SIST_MAINFORM.dfm` guarda 39 imagens de 64×64 numa
 * única tira, e cada item do menu aponta para ela por `ImageIndex`. Este mapa é
 * a transcrição dessa ligação: código da rotina → índice na lista.
 *
 * Os PNGs correspondentes vivem em `public/icones/rotinas/NN.png`, gerados a
 * partir do mesmo `.dfm`. Ficam em `public/` de propósito: são buscados pelo
 * código da rotina em tempo de execução, e um import estático exigiria conhecer
 * todos os nomes em tempo de build.
 *
 * O mapa cobre as 60 rotinas que o Delphi ilustra, não apenas as que já existem
 * aqui — assim uma rotina migrada depois já nasce com o ícone certo, sem
 * ninguém precisar voltar ao Delphi.
 *
 * GERADO A PARTIR DO DELPHI. Para atualizar, reexecute a extração descrita em
 * `docs/icones-rotinas.md`.
 */
export const ICONES_ROTINAS: Record<string, number> = {
	"1268": 18,  // 1268 - Movimenta
	"34F2": 0,  // 34F2 - Auditoria dos Volumes Separados por Carga (C)
	"413": 1,  // 413 - Consulta dos Paletes dos Volumes do Picking de Unida
	"99": 0,  // 99 - Teste para Novas Funcionalidades
	B11: 4,  // B11 - Dados Log
	B12: 32,  // B12 - Cadastro de C
	B13: 33,  // B13 - Alterar Data de Validade
	B21: 0,  // B21 - Confer
	B22: 0,  // B22 - Sequencial de Invent
	B23: 8,  // B23 - Vinculo das Mercadorias aos Endere
	B231: 8,  // B231 - Vinculo End Pulm
	B237: 8,  // B237 - Vinculo End Pulmao
	B235: 8,  // B235 - Vinculo End Pulmao
	B234: 8,  // B234 - Vinculo End Pulmao
	B232: 8,  // B232 - Vinculo End Pulmao
	B233: 8,  // B233 - Vinculo End Pulm
	B24: 0,  // B24 - Vinculo das Mercadorias aos Endere
	B241: 7,  // B241 - Vinculo ao Pikcing com Etiqueta de Identifica
	B242: 7,  // B242 - Vinculo ao Picking com Endereçamento Sequenciado
	B311: 9,  // B311 - Confer
	B312: 10,  // B312 - Confer
	B314: 16,  // B314 - Registro de Apontamento da Produ
	B316: 8,  // B316 - Armazenamento de Devolu
	B321: 11,  // B321 - Averigua
	B322: 12,  // B322 - Gera
	B323: 13,  // B323 - Averigua
	B324: 16,  // B324 - Averigua
	B3241: 16,  // B3241 - Averigua
	B3242: 16,  // B3242 - Averigua
	B325: 16,  // B325 - Reconfer
	B326: 16,  // B326 - Separa
	B327: 17,  // B327 - Localiza
	B328: 19,  // B328 - Ve
	B329: 24,  // B329 - Paletes para Carregamento (U)
	B32B: 1,  // B32B - Paletes Localiza
	B32C: 8,  // B32C - Guarda Volumes Fracionado
	B32D: 9,  // B32D - Verifica
	B32F1: 26,  // B32F1 - Flow Rack - In
	B32F2: 28,  // B32F2 - Flow Rack - In
	B32F3: 31,  // B32F3 - Flow Rack - Separador
	B331: 14,  // B331 - Aguardar Convoca
	B332: 15,  // B332 - Liberação do Palete para Armazenamento
	B333: 12,  // B333 - Convoca
	B341: 16,  // B341 - Registro das Informa
	B342: 17,  // B342 - Invent
	B343: 0,  // B343 - An
	// Acrescentado à mão: a legenda desta rotina quebra em duas linhas no
	// `.dfm` (`SIST_MAINFORM.dfm:3470-3472`) e a extração automática a pulou.
	// `ImageIndex = 24`, lido no mesmo bloco.
	B344: 24,  // B344 - Registro da Conferência das Posições Paletes (Cara-Crachá)
	B345: 1,  // B345 - Verifica
	B346: 7,  // B346 - Verifica
	B347: 17,  // B347 - Invent
	B348: 7,  // B348 - Associar ao Usu
	B351: 18,  // B351 - Confer
	B3611: 19,  // B3611 - Expedi
	B3612: 20,  // B3612 - Expedi
	B3613: 0,  // B3613 - Expedi
	B3621: 21,  // B3621 - Recep
	B3622: 22,  // B3622 - Recep
	B371: 0,  // B371 - N
	B381: 3,  // B381 - End Intermedi
	B382: 8,  // B382 - End Intermedi
	B391: 15,  // B391 - Remonte com Mesma Mercadoria (U)
	B3A1: 7,  // B3A1 - Devolver Mercadoria ao Picking
	B41: 5,  // B41 - Consulta Mercadoria / Rua / U.M.A (U)
	B42: 8,  // B42 - Consulta Saldo F
	D1181: 9,  // D1181 - Revis
	D1335: 7,  // D1335 - Internaliza
};

/**
 * Caminho do ícone da rotina, ou `null` quando o Delphi não ilustra essa rotina.
 *
 * @param tela Código da rotina, como `B321` — o mesmo `tela` que o menu carrega.
 */
export function iconeDaRotina(tela?: string): string | null {
	const codigo = codigoDaRotina(tela)?.toUpperCase();
	const indice = codigo ? ICONES_ROTINAS[codigo] ?? ICONES_MANUAIS[codigo] : undefined;

	return indice === undefined ? null : `/icones/rotinas/${String(indice).padStart(2, "0")}.png`;
}

/**
 * Ícones atribuídos à mão, para rotinas que o Delphi não ilustra.
 *
 * O `ICONES_ROTINAS` acima é transcrição do `.dfm` e só contém o que existe lá.
 * Rotinas que nasceram no web, ou que o menu do Delphi nunca ilustrou, entram
 * aqui — sempre reaproveitando um índice já extraído, para o conjunto continuar
 * visualmente coerente.
 */
export const ICONES_MANUAIS: Record<string, number> = {
	// B315 é a conferência de planilha cega por U.M.A., variante da B311 — mesma
	// operação, mesma prancheta com visto.
	B315: 9,
};

/**
 * Nome do formulário → código da rotina.
 *
 * A partir da r187 as rotinas do menu passaram a declarar `tela` com o nome do
 * formulário (`PROC_AVERIGUACAO_PICKING_CX_COLETOR`) em vez do código curto
 * (`B321`). O mapa de ícones é indexado por código, porque é assim que o Delphi
 * organiza a `ImageListColetor` — então a tradução acontece aqui, num lugar só.
 *
 * Sem isto o menu mostra o nome do formulário como se fosse o código e todos os
 * ícones caem no genérico.
 */
export const CODIGO_POR_FORMULARIO: Record<string, string> = {
	PROC_AVERIGUACAO_PICKING_CX_COLETOR: "B321",
	PROC_AVERIGUACAO_AUDITORIA_SEPARACAO_COLETOR: "34F2",
	PROC_CADASTRO_DADOS_LOGISTICOS_COLETOR: "B11",
	PROC_CADASTRO_DADOS_CODIGOBARRAS_COLETOR: "B12",
	PROC_PALETES_LOCALIZACAO_DOCA: "B32B",
	PROC_INVENTARIO_COLETOR: "B341",
	PROC_SEPARACAO_PICKING_UNIDADE_COLETOR: "B326",
	PROC_CONSULTA_SALDO_ESTOQUE_COLETOR: "B41",
	PROC_INVENTARIO_COLETOR_ASSOCIAR_LOTE: "B348",
	PROC_INVENTARIO_EXPRESSO_COLETOR: "B342",
	// `SIST_MAINFORM.dfm:3471` — "B344 - Registro da Conferência das Posições
	// Paletes (Cara-Crachá)". Estava mapeada como B351, código que não existe no
	// menu do Delphi; o ícone caía no genérico.
	PROC_CARA_CRACHA_CONF_COLETOR: "B344",
	PROC_AVERIGUACAO_CAIXA_UNIDADE: "B323",
	PROC_CONSULTA_ENDERECO: "B41",
	PROC_CONS_MERC_COLETOR: "B41",
	// "B332 - Liberação do Palete para Armazenamento" no catálogo do Delphi.
	// O código não pôde ir direto em `tela` porque outra rotina do menu já o
	// declara literalmente — ver o comentário em convocacaoAtiva/rotinas.ts.
	PROC_CONV_ATIVA_COLAGEM_CRACHA: "B332",
};

/**
 * Código da rotina, seja `tela` um código ou um nome de formulário.
 *
 * @param tela Valor que o menu carrega em `item.tela`.
 */
export function codigoDaRotina(tela?: string): string | null {
	if (!tela) return null;

	return CODIGO_POR_FORMULARIO[tela] ?? tela;
}
